import { TOptionalProductDetails } from 'types';
import { cdmApi } from '.';

const PREFIX = '/pdp';

const pdpApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        // change any to proper type later
        getPDP: builder.query<any, { lang: string; retailer: string | number; date: string }>({
            query: (params) => ({ url: PREFIX, method: 'get', params }),
            providesTags: () => [{ type: 'pdp', id: 'LIST' }],
        }),

        // change any to proper type later
        createPDP: builder.mutation<any, any>({
            query: (data) => ({
                url: `${PREFIX}`,
                method: 'post',
                data,
            }),
            invalidatesTags: [{ type: 'pdp', id: 'LIST' }],
        }),

        updatePDP: builder.mutation<any, TOptionalProductDetails>({
            query: (data) => ({
                url: PREFIX,
                method: 'put',
                data,
            }),
            invalidatesTags: [{ type: 'pdp', id: 'LIST' }],
        }),

        deletePDPs: builder.mutation<any, string[]>({
            query: (pdps) => ({
                url: `${PREFIX}`,
                method: 'delete',
                data: { ids: pdps },
            }),
            invalidatesTags: [{ type: 'pdp', id: 'LIST' }],
        }),

        exportPDPs: builder.query<
            ArrayBuffer,
            { lang?: string; retailer?: string | number; date?: string; isTemplate?: boolean }
        >({
            query: (params) => ({
                url: `${PREFIX}/excel/export`,
                method: 'get',
                params,
                responseType: 'arraybuffer',
            }),
        }),

        uploadPDPs: builder.mutation<any, FormData>({
            query: (data) => ({ url: `${PREFIX}/excel/upload`, method: 'POST', data }),
            invalidatesTags: [{ type: 'pdp', id: 'LIST' }],
        }),


        exportPDPsErrors: builder.mutation<ArrayBuffer, any>({
            query: (data) => ({
                url: `${PREFIX}/excel/error`,
                method: 'post',
                data,
                responseType: 'arraybuffer',
            }),
        }),
    }),

    overrideExisting: false,
});

export const {
    useGetPDPQuery,
    useCreatePDPMutation,
    useDeletePDPsMutation,
    useUpdatePDPMutation,
    useLazyExportPDPsQuery,
    useUploadPDPsMutation,
    useExportPDPsErrorsMutation,
} = pdpApi;
